'use strict';
import React, { PureComponent } from 'react';
import Procesos from './Procesos';

class SeccionProcesos extends PureComponent {
    constructor(props) {
        super(props);

        this.desplegarProcesos = this.desplegarProcesos.bind(this);
    }

    desplegarProcesos(estaDesplegado) {
        this.props.desplegarProcesos(estaDesplegado);
    }
    render() {
        const {
            barraAvance,
            comboProceso,
            datosCombo,
            estaDesplegado,
            habilitarEjecucionReconta,
            hayProcesosEnEjecucion,
            radioButtonsContabilizador
        } = this.props;

        //ACTIONS
        const {
            cambiarValorCombo,
            cargarRegistrosDatosEjecucion,
            mostrarOcultarModalContabilizadorRecontabilizador,
        } = this.props;

        const valorRBContabilizacion = radioButtonsContabilizador.contabilizacion;

        let estiloFlechaDesplegado = estaDesplegado ? "seccionRenglonesModelo__renglonModelo__trianguloUp seccionRenglonesModelo__renglonModelo__triangulo--noMarginTop" : "seccionRenglonesModelo__renglonModelo__trianguloDown seccionRenglonesModelo__renglonModelo__triangulo--noMarginTop"
        let datosBarraAvance = barraAvance[0];
        let fechaFormateada = "-";
        let porcentaje = 0;
        let estiloEstadoProceso = " ContabilizadorRecontabilizador__registroProceso--SinProcesos";
        
        //se chequea si existen datos en "datosBarraAvance" y posteriormente si hay procesos ejecutados,
        // en caso de que no se cumplan estas condiciones, el porcentaje queda en 0%
        if(datosBarraAvance)
        {
            if(datosBarraAvance.CantidadProcesosEjecutados != 0)
            {
               let fecha = new Date(datosBarraAvance.FechaContabilidadOriginal ? datosBarraAvance.FechaContabilidadOriginal : datosBarraAvance.FechaEjecucion);
               let dia = fecha.getDate().toString().padStart(2, '0');
               let mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
               
               fechaFormateada = `${dia}/${mes}/${fecha.getFullYear()}`;
               porcentaje=((datosBarraAvance.CantidadProcesosEjecutados / datosBarraAvance.CantidadProcesosTotales) * 100)
            }

        switch (datosBarraAvance.ColorUltimaEjecucion) {
            case "VERDE":
                estiloEstadoProceso = " ContabilizadorRecontabilizador__registroProceso--ProcesoOk";
                break;
            case "ROJO":
                estiloEstadoProceso = " ContabilizadorRecontabilizador__registroProceso--ProcesoError";
                break;
            case "AZUL":
                estiloEstadoProceso = " ContabilizadorRecontabilizador__registroProceso--ProcesoEnEjecucion";
                break;        
            default:
                estiloEstadoProceso = " ContabilizadorRecontabilizador__registroProceso--SinProcesos";
             }
        }

        let porcentajeCompletado = porcentaje.toFixed(1) + "%"

        return (
            <div className="ContabilizadorRecontabilizador__contenedorSeccionProcesos">
                <div className="AsientosContables--overflowHidden">
                    <div className="AsientosContables--floatLeft ContabilizadorRecontabilizador__contenedorBarraProgreso">
                        <div className={"ContabilizadorRecontabilizador__barraProgreso" + estiloEstadoProceso} style={{ width: porcentajeCompletado }}>
                            <div className="ContabilizadorRecontabilizador__barraProgresoDescripcion">{(valorRBContabilizacion == 0 ? "Contabilización" : "Re-contabilización") + " del " + fechaFormateada + ": " + porcentajeCompletado}</div>
                        </div>
                    </div>

                    <div className="AsientosContables--floatLeft ContabilizadorRecontabilizador__flechaDesplegar">
                        <div className={estiloFlechaDesplegado} onClick={() => this.desplegarProcesos(!estaDesplegado)}></div>
                    </div>
                </div>

                <Procesos
                    barraAvance={barraAvance}
                    cambiarValorCombo={cambiarValorCombo}
                    cargarRegistrosDatosEjecucion={cargarRegistrosDatosEjecucion}
                    comboProceso={comboProceso}
                    datosCombo={datosCombo}
                    esContabilizacion={valorRBContabilizacion == 0}
                    estaDesplegado={estaDesplegado}
                    hayProcesosEnEjecucion={hayProcesosEnEjecucion}
                    habilitarEjecucionReconta={habilitarEjecucionReconta}
                    mostrarOcultarModalProceso={mostrarOcultarModalContabilizadorRecontabilizador}
                />
            </div>
        );
    }
}

export default SeccionProcesos;